/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InternalMCPTaskStatus = {
    Working: 'working',
    InputRequired: 'input_required',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;
export type InternalMCPTaskStatus = typeof InternalMCPTaskStatus[keyof typeof InternalMCPTaskStatus];


export function instanceOfInternalMCPTaskStatus(value: any): boolean {
    for (const key in InternalMCPTaskStatus) {
        if (Object.prototype.hasOwnProperty.call(InternalMCPTaskStatus, key)) {
            if (InternalMCPTaskStatus[key as keyof typeof InternalMCPTaskStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalMCPTaskStatusFromJSON(json: any): InternalMCPTaskStatus {
    return InternalMCPTaskStatusFromJSONTyped(json, false);
}

export function InternalMCPTaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPTaskStatus {
    return json as InternalMCPTaskStatus;
}

export function InternalMCPTaskStatusToJSON(value?: InternalMCPTaskStatus | null): any {
    return value as any;
}

export function InternalMCPTaskStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalMCPTaskStatus {
    return value as InternalMCPTaskStatus;
}

